import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../../../../../../../redux/slices";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { changeStatusSpeciesFilter } from "../../../../../../../../../redux/slices/dataTable/dataTableFilters";
import { DataTableFiltersStyles } from "../../../FiltersSideBarStyles";
import { CircularProgress } from "@mui/material";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  return {
    changeStatusSpeciesFilter: (id: number) => {
      dispatch(changeStatusSpeciesFilter(id));
    },
  };
};
type SpecieFilterProps = {
  loading: boolean;
};

const SpecieFilter: FC<SpecieFilterProps> = ({ loading }) => {
  const { changeStatusSpeciesFilter } = SetActions();

  const { speciesList } = useSelector(
    (state: State) => state.DataFiltersReducer,
  );

  const sortedSpeciesList = [...speciesList].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
  );

  return (
    <List sx={DataTableFiltersStyles.SpeciesFilter}>
      {!loading || speciesList.length === 0 ? (
        sortedSpeciesList.map((value) => {
          const labelId = `checkbox-list-label-${value.id}`;

          return (
            <ListItem key={value.id} disablePadding>
              <ListItemButton
                role={undefined}
                onClick={() => changeStatusSpeciesFilter(value.id)}
                dense
              >
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={value.isSelected}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={`${value.name}`} />
              </ListItemButton>
            </ListItem>
          );
        })
      ) : (
        <div className="circular-progress-components">
          <CircularProgress />
        </div>
      )}
    </List>
  );
};

export default SpecieFilter;
